import { faStar } from "@jewlr/pro-solid-svg-icons/faStar"
import { faStarHalf } from "@jewlr/pro-solid-svg-icons/faStarHalf"

import LandingPerks from "areas/landing/elements/landing-perks"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Media from "components/ui/media"
import { jewlr_t, IS_JEWLR } from "helpers/application"

import EmptyOutCart from "../empty-out-cart"
import Help from "../help-footer"

import AcceptPayments from "./accept-payments"

const Footer = () => {
  const perksProps = {
    data: { show_heading: false },
  }

  return (
    <>
      {IS_JEWLR() && (
        <>
          <div className="contained tablet:mt-40 mt-24">
            <LandingPerks element={perksProps} />
            <Media className="mb-40 px-48 text-center" lessThan="tablet">
              <p className="text-18 mb-6 font-bold">Customer Reviews</p>
              <p className="text-12 mb-6 font-medium">
                {jewlr_t("terms.Jewelry")} And Customer Experience Is Our
                Passion, And Our Customers Love Us For It.
              </p>
              <p className="text-18 mb-6 font-bold">50K+</p>
              <div className="flex justify-center gap-2">
                <FontAwesomeIcon
                  className="text-rating text-12"
                  icon={faStar}
                />
                <FontAwesomeIcon
                  className="text-rating text-12"
                  icon={faStar}
                />
                <FontAwesomeIcon
                  className="text-rating text-12"
                  icon={faStar}
                />
                <FontAwesomeIcon
                  className="text-rating text-12"
                  icon={faStar}
                />
                <FontAwesomeIcon
                  className="text-rating text-12"
                  icon={faStarHalf}
                />
              </div>
            </Media>
          </div>
          <Media className="contained px-16" lessThan="tablet">
            <Help />
          </Media>
        </>
      )}
      <EmptyOutCart />
      <AcceptPayments />
    </>
  )
}
export default Footer
